import './index.scss';

import { FaShoppingCart } from 'react-icons/fa';

import { useDevice } from '@/resources/hooks/useDevice';
import { useTextColor } from '@/resources/hooks/useTextColor';
import { useWebContext } from '@/resources/hooks/useWebContext';

export default function CartLoad() {
  const { configs } = useWebContext();
  const { device } = useDevice();
  const color = useTextColor(configs.bg_color);
  const particleCount = device === 'mobile' ? 8 : 15;

  return (
    <>
      <div className="cart-load" style={{ color }}>
        <div className="cart-load__particles">
          {[...Array(particleCount)].map((_, i) => (
            <div
              key={i}
              className="cart-load__particle"
              style={{
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 8}s`,
                animationDuration: `${3.2 + Math.random() * 2.4}s`,
              }}
            />
          ))}
        </div>
        <FaShoppingCart className="cart-load__icon" />
      </div>
    </>
  );
}
